import createModelStore from "../../utils/createModelStore";
import PriceZone from "../../services/PriceZone";

const priceZones = createModelStore<PriceZone.Model, "priceZones">(
	"priceZones",
);

export default priceZones;
